module.exports = __webpack_public_path__ + "img/img9.a020c1f9.jpg";